export default build =>
    build.mutation({
        query(payload) {         
            return {
                url: '/photogallery/deleteEventName',
                method: 'POST',
                body: payload,
            };
        },
        invalidatesTags: ['eventByYear'],
       
    })
